import { gql } from '@/features/graphql/generated'

export const cashTransactionCreateMutation = gql(/* GraphQL */ `
    mutation CashTransactionCreate($transaction: CashTransactionCreateInput!) {
        cashTransactionCreate(transaction: $transaction) {
            amount {
                amount
                currency
            }
            id
            note
            transactedAt
            type
        }
    }
`)

export const shiftCloseoutCreateMutation = gql(/* GraphQL */ `
    mutation ShiftCloseoutCreate($reportedPaymentTotals: [ShiftCloseoutPaymentTotalInput!]!) {
        shiftCloseoutCreate(reportedPaymentTotals: $reportedPaymentTotals) {
            uuid
        }
    }
`)
